import React from "react";
import Image from "next/image";
import classNames from "classnames";
import { CustomLoader } from "@shared/ui/CustomLoader";
import { ImgSelectorProps } from "./types";
import classes from "./ImgSelector.module.scss";

const ImgSelector = ({ options, onSelect, selected, isLoading = false }: ImgSelectorProps) => {
    const placeholder = "/img/placeholder-generation.png";

    return (
        <div className={classes["img-selector"]}>
            {isLoading && <CustomLoader />}
            {options.map((item, index) => (
                <div
                    key={index}
                    onClick={() => onSelect(item.label)}
                    className={classNames(classes["img-selector__item"], {
                        [classes["img-selector__item--active"]]: item.label === selected
                    })}
                >
                    {item.imgUrl && (
                        <div className={classes["img-selector__wrapper"]}>
                            <Image
                                className={classes["img-selector__wrapper--image"]}
                                src={item.imgUrl}
                                alt={item.label}
                                fill={true}
                                onError={(e) => {
                                    e.currentTarget.src = placeholder;
                                    e.currentTarget.srcset = placeholder;
                                }}
                            />
                        </div>
                    )}
                    <span>{item.label}</span>
                </div>
            ))}
        </div>
    );
};

export default ImgSelector;